import { Data } from "../interface/Data";

// --------------- SERVER --------------- //
export const SERVER_BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:8011/";
export const SOCKET_SERVER_URL = import.meta.env.VITE_EQUATIONS_URL || "http://localhost:8015/ws";


// --------------- IDS --------------- //
export const KEYS = {
  // --------------- PARAMETER IDS --------------- //
  TEMP_CONSIGNE: "temp",
  WINDOW: "window",
  CURTAINS: "curtains",
  MECHANICAL_VENT: "mecanical_ventilation",
  PORTABLE_VENT: "portable-vent",
  ARTIFICIAL_LIGHT: "artificial_light",
  AL_USAGE: "electric_equipement",
  CLOTHING: "dressing",
  // --------------- FACTOR IDS --------------- //
  HEATING: "chauffage",
  AIR_CONDITIONER: "climatisation",
  ELECTRICITY: "electricity",
  AIR_QUALITY: "air_quality",
  ACOUSITC_COMFORT: "acoustic-comfort",
  VISUAL_COMFORT: "visual_comfort",
  THERMIC_COMFORT: "thermal_comfort",
  COST: "cost",
  GES: "ges",
  RESULTS: "results"
}

export const FACTOR_KEYS = [
  KEYS.TEMP_CONSIGNE,
  KEYS.WINDOW,
  KEYS.CURTAINS,
  KEYS.MECHANICAL_VENT,
  KEYS.PORTABLE_VENT,
  KEYS.ARTIFICIAL_LIGHT,
  KEYS.AL_USAGE,
  KEYS.CLOTHING
]

// --------------- TITLES --------------- //
export const PARAMTER_TITLES = new Map<string, string>([
  // --------------- PARAMETER TITLES --------------- //
  [KEYS.TEMP_CONSIGNE, "Température de consigne"],
  [KEYS.WINDOW, "Ouverture des fenêtres"],
  [KEYS.CURTAINS, "Ouverture des rideaux"],
  [KEYS.MECHANICAL_VENT, "Ventilation mécanique"],
  [KEYS.PORTABLE_VENT, "Ventilateur portable"],
  [KEYS.ARTIFICIAL_LIGHT, "Éclairage artificiel"],
  [KEYS.AL_USAGE, "Utilisation d'appareil électrique"],
  [KEYS.CLOTHING, "Habillement"],
  // --------------- FACTOR TITLES --------------- //
  [KEYS.HEATING, "Chauffage"],
  [KEYS.AIR_CONDITIONER, "Climatisation"],
  [KEYS.ELECTRICITY, "Électricité"],
  [KEYS.AIR_QUALITY, "Qualité de l'air"],
  [KEYS.ACOUSITC_COMFORT, "Confort acoustique"],
  [KEYS.VISUAL_COMFORT, "Confort visuel"],
  [KEYS.THERMIC_COMFORT, "Confort thermique"],

  [KEYS.COST, "Coûts"],
  [KEYS.GES, "Gaz à effet de serre (GES)"]
])

// --------------- GRAPH WINDOW --------------- //
export const GRAPH_WINDOW_WIDTH = 3;
export const GRAPH_WINDOW_OFFSET_X = 100;
export const GRAPH_WINDOW_ARROW_POSITION_Y = 275;
export const GRAPH_WINDOW_ARROW_HEIGHT = 30;

export const GRAPH_WINDOW_TEXT_MARGIN = 10;
export const GRAPH_WINDOW_FONT_SIZE = 15;

export const GRAPH_WINDOW_EQUATION_MARGIN = 30;


// --------------- SCALES --------------- //
export const SCALE_FILL_COLOR = "#cd7f32";
export const LOW_VALUE_FILL_COLOR = "#8B0000"
export const MID_VALUE_FILL_COLOR = "#00008B"
export const HIGH_VALUE_FILL_COLOR = "#008B00"

// --------------- CONTROLLER ------------//
export const DEFAULT_STROKE_WIDTH = 2;

// --------------- GAME --------------- //
export const DEFAULT_AVAILABLE_POINTS = 15;
export const DEFAULT_DATA: Data = {
  temp: 10,
  window: 1,
  curtains: 5,
  mecanical_ventilation: 3,
  artificial_light: 11,
  electric_equipement: 3,
  dressing: 3,
  clim_on_off:1,
}


// ---------- TIMER COMPONENTS ---------- //
export const SLEEP_TIME = {
  hours: 23,
  minutes: 0
};

export const BEGIN_TIME = {
  hours: 7,
  minutes: 0
}


export const TICK = 10;
export const TICK_DURATION = 50;
export const TRANSITION_DURATION = 200;

